import React from "react";
import { Typography } from "@mui/material";
import TranslationContent from "../../../../Translations/TranslationContent";


const HeaderDuplicate = () => {
  return <Typography sx={{color: "black"}} variant="body2"><TranslationContent contentID="headerDuplicateDesc" /></Typography>
}

export default HeaderDuplicate;